"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalCostOfCapitalFormula = void 0;
exports.getTotalCostOfCapital = getTotalCostOfCapital;
const general_formulas_1 = require("./general-formulas"); /*
 
* Enumeration of TotalCostOfCapital formala implementation names
 */
var TotalCostOfCapitalFormula;
(function (TotalCostOfCapitalFormula) {
    TotalCostOfCapitalFormula[TotalCostOfCapitalFormula["DEFAULT"] = 0] = "DEFAULT";
})(TotalCostOfCapitalFormula || (exports.TotalCostOfCapitalFormula = TotalCostOfCapitalFormula = {}));
/**
 * Returns the specified draw fee formula implementation
 */
function getTotalCostOfCapital(formula) {
    switch (formula) {
        default:
            return default_totalCostOfCapital;
    }
}
///////////////////////////
// Function Implementations
///////////////////////////
const default_totalCostOfCapital = (totalInterest, drawFeeAmount) => {
    // ensure valid argument types
    if (typeof totalInterest === 'number' && typeof drawFeeAmount === 'number') {
        return (0, general_formulas_1.toFixedNumber)(totalInterest + drawFeeAmount, 2);
    }
    return NaN;
};
//# sourceMappingURL=total-cost-of-capital-formula.js.map